query MobileDashboardData(
	$days: Int!
	$days2n: Int!
	$customFieldsFilter: ConditionStringArray
	$customFieldsFilterExcludes: ConditionStringArray
	$mfaOsFilter: ConditionStringArray
	$mfaAppIdFilter: ConditionStringArray
	$msdkOsFilter: ConditionString
	$msdkAppFilter: ConditionString
	$platformScoreFilter: ConditionString
	$appIdScoreFilter: ConditionString
	$unitIdScoreFilter: ConditionString
	$platformMuiFilter: ConditionString
	$appIdMuiFilter: ConditionString
	$businessUnitMobileFilter: ConditionString
) {
	mfaIssuesCount: mfa_session_runs(
		run_updated_at_last_n_days: { value: [$days] }
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item_for_any_value: $mfaOsFilter
		app_id_eq_any_item_for_any_value: $mfaAppIdFilter
		group: run_updated_at_truncDay
	) {
		run_updated_at_truncDay
		critical_issues_sum
		serious_issues_sum
		total_issues_sum
	}
	mfaIssuesCount2n: mfa_session_runs(
		run_updated_at_last_n_days: { value: [$days2n] }
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item_for_any_value: $mfaOsFilter
		app_id_eq_any_item_for_any_value: $mfaAppIdFilter
		group: run_updated_at_truncDay
	) {
		run_updated_at_truncDay
		critical_issues_sum
		serious_issues_sum
		total_issues_sum
	}
	msdkIssuesCount: msdk_report_runs(
		run_time_last_n_days: { value: [$days] }
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq: $msdkOsFilter
		app_eq: $msdkAppFilter
		group: run_time_truncDay
	) {
		run_time_truncDay
		critical_issues_sum
		serious_issues_sum
		total_issues_sum
	}
	msdkIssuesCount2n: msdk_report_runs(
		run_time_last_n_days: { value: [$days2n] }
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq: $msdkOsFilter
		app_eq: $msdkAppFilter
		group: run_time_truncDay
	) {
		run_time_truncDay
		critical_issues_sum
		serious_issues_sum
		total_issues_sum
	}
	mfaSummary: mfa_session_runs(
		run_updated_at_last_n_days: { value: [$days] }
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item_for_any_value: $mfaOsFilter
		app_id_eq_any_item_for_any_value: $mfaAppIdFilter
	) {
		critical_issues_sum
		total_issues_sum
		run_updated_at_max
	}
	msdkSummary: msdk_report_runs(
		run_time_last_n_days: { value: [$days] }
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq: $msdkOsFilter
		app_eq: $msdkAppFilter
	) {
		critical_issues_sum
		total_issues_sum
		run_time_max
	}
	scoreMobileProductsDaily: score_mobile_products(
		timeframe_days_eq: { value: [$days] }
		calculation_date_last_n_days: { value: [$days] }
		unit_id_eq: $unitIdScoreFilter
		platform_eq: $platformScoreFilter
		app_id_eq: $appIdScoreFilter
		sort: { fields: [calculation_date], order: Ascending }
	) {
		issues: unique_issues
		issues_critical: unique_issues_critical
		issues_serious: unique_issues_serious
		calculation_date
		created_at
	}
	scoreMobileProductsDailyTotal: score_mobile_products(
		timeframe_days_eq: { value: [$days] }
		calculation_date_last_n_days: { value: [$days] }
		unit_id_eq: $unitIdScoreFilter
		platform_eq: $platformScoreFilter
		app_id_eq: $appIdScoreFilter
		sort: { fields: [calculation_date], order: Ascending }
	) {
		issues: total_issues
		issues_critical: total_issues_critical
		issues_serious: total_issues_serious
		calculation_date
	}
	mobileUniqueIssuesCount: mobile_unique_issues(
		last_seen_last_n_days: { value: [$days] }
		platform_eq: $platformMuiFilter
		app_id_eq: $appIdMuiFilter
		business_unit_eq: $businessUnitMobileFilter
	) {
		signature_count
	}
	mobileUniqueIssuesPrevCount: mobile_unique_issues(
		last_seen_last_n_days: { value: [$days2n] }
		platform_eq: $platformMuiFilter
		app_id_eq: $appIdMuiFilter
		business_unit_eq: $businessUnitMobileFilter
	) {
		signature_count
	}
	mobileUniqueIssuesCriticalCount: mobile_unique_issues(
		last_seen_last_n_days: { value: [$days] }
		platform_eq: $platformMuiFilter
		app_id_eq: $appIdMuiFilter
		business_unit_eq: $businessUnitMobileFilter
		severity_eq: { value: ["CRITICAL"] }
	) {
		signature_count
	}
	mobileUniqueIssuesCriticalPrevCount: mobile_unique_issues(
		last_seen_last_n_days: { value: [$days2n] }
		platform_eq: $platformMuiFilter
		app_id_eq: $appIdMuiFilter
		business_unit_eq: $businessUnitMobileFilter
		severity_eq: { value: ["CRITICAL"] }
	) {
		signature_count
	}
}
